// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from "@apollo/client";
export var SET_GOOGLE_SERVICE_ACCOUNT_KEY = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation SetGoogleServiceAccountKey($serviceAccountKey: jsonb!) {\n        set_google_service_account_key(service_account_key: $serviceAccountKey) {\n            client_email\n        }\n    }\n"], ["\n    mutation SetGoogleServiceAccountKey($serviceAccountKey: jsonb!) {\n        set_google_service_account_key(service_account_key: $serviceAccountKey) {\n            client_email\n        }\n    }\n"])));
var templateObject_1;
